import * as angular from "angular";
import { Endpoints } from "../../shared/config/constant.module";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import HttpServiceName, { HttpService } from "../http/http.service";
import * as moment from "moment";

export interface ScoreCardService {
  getScorecardChecklists(plantId: string, reportDate: Date): angular.IPromise<apsViewModels.ScoreCardCheckListInstance>;
  exportToExcelV2(plantName: string, productionDate: Date, b64Data: any);
}

class scorecardServiceImpl implements ScoreCardService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  } 

  getScorecardChecklists(plantId: string, reportDate: Date) {
    return this.httpService.get<apsViewModels.ScoreCardCheckListInstance>(Endpoints.SCORECARD,{plantId: plantId, reportDate: reportDate});
  }

  exportToExcelV2(plantName: string, productionDate: Date, b64Data: any) {
    const byteCharacters = atob (b64Data);
    const byteNumbers = new Array (byteCharacters.length);
    for (let i = 0; i <byteCharacters.length; i ++) {
      byteNumbers [i] = byteCharacters.charCodeAt (i);
    }
    const byteArray = new Uint8Array (byteNumbers);
    let blob = new Blob ([byteArray], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    const url = window.URL.createObjectURL (blob);
    const anchor = document.createElement ('a');
    var reportDate = moment(productionDate).format("MM/DD/YYYY");
    anchor.download = 'ScoreCardReport_'+ plantName + '_'+reportDate+'.xlsx';
    anchor.href = url;
    anchor.click ();
  }
}

export default angular
  .module('aps.services.scorecardService', [HttpServiceName])
  .service('scorecardService', scorecardServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/scorecard.service.ts